import { CommercialPageShell } from "@/components/commercial/commercial-page-shell";

const PATH = "/commercial-case-studies";
const PAGE_TITLE = "Case Studies";

export function LpCommercialCaseStudies() {
  return (
    <CommercialPageShell
      pageTitle={PAGE_TITLE}
      pagePath={PATH}
      sourcePage={PATH}
      serviceOfInterest="Case Studies Enquiry"
      submitLabel="Register Interest"
      footnote="We share project references, scope notes and photo evidence on request."
      intro={
        <>
          <p className="text-xs font-bold uppercase tracking-widest text-accent mb-2">Case Studies</p>
          <h1 className="text-2xl md:text-4xl font-bold text-foreground leading-tight mb-4">
            {PAGE_TITLE}
          </h1>
          <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
            Selected commercial and framework projects with scope, risks managed and outcomes.
            Detailed case studies and verbal references are available on request. Use the form
            below to tell us the sector and works you are procuring for and we will share the
            most relevant references.
          </p>
        </>
      }
    >
      <></>
    </CommercialPageShell>
  );
}

export { PATH as COMMERCIAL_CASE_STUDIES_PATH, PAGE_TITLE as COMMERCIAL_CASE_STUDIES_TITLE };
